import { Trans, useLingui } from '@lingui/react/macro';
import { BulbOutlined } from '@ant-design/icons';
import { Modal, Tabs } from 'antd';
import { useTheme } from '../context/ThemeContext';
import LanguageSelect from './LanguageSelect';
import styles from './PersonalSettingsModal.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  restoreFocus: () => void;
}

export default function PersonalSettingsModal({ open, onClose, restoreFocus }: Props) {
  const { t } = useLingui();
  const { theme, toggleTheme } = useTheme();

  return (
    <Modal
      open={open}
      title={t`Settings`}
      onCancel={onClose}
      afterClose={restoreFocus}
      focusable={{ focusTriggerAfterClose: false }}
      footer={null}
      centered
      width={960}
      className={styles.dialog}
      destroyOnHidden
    >
      <div className={styles.content} data-testid="personal-settings">
        <Tabs
          defaultActiveKey="general"
          tabPlacement="start"
          className={styles.tabs}
          items={[{
            key: 'general',
            label: t`General`,
            children: (
              <div className={styles.preferences}>
                <div className={styles.preference}>
                  <LanguageSelect />
                </div>
                <div className={`${styles.preference} ${styles.theme}`}>
                  <span><Trans>Theme</Trans></span>
                  <button type="button" className={styles.themeToggle} onClick={toggleTheme}>
                    <BulbOutlined aria-hidden="true" />
                    <span>{theme === 'light' ? t`Dark Mode` : t`Light Mode`}</span>
                  </button>
                </div>
              </div>
            ),
          }]}
        />
      </div>
    </Modal>
  );
}
